import { ROUTE_CALENDAR_DETAILS } from '@/constants/routes';
import HeaderTemplate from '@/templates/Header.template';
import PageSectionTemplate from '@/templates/PageSection.template';
import { Box, Button, Text } from '@chakra-ui/react';
import { t } from 'i18next';
import { Link } from 'react-router-dom';
import { useListCalendarsController } from './calendar-list-page.controller';

export default function CalendarListPage() {
	const { query, handleCreateCalendarClick } = useListCalendarsController();

	return (
		<PageSectionTemplate>
			<HeaderTemplate left={<></>} center={t('Calendars')} />
			<Box p={4}>
				{!query.data?.items.length ? <Text mb={4}>There are no calendars</Text> : null}

				<Box overflow="auto" display="grid" gap={1}>
					{query.data?.items.map((calendar) => {
						return (
							<Box
								as={Link}
								to={`${ROUTE_CALENDAR_DETAILS}?ids=${calendar.id}`}
								p={4}
								bg="white"
								borderColor="gray.200"
								borderWidth={1}
								borderRadius="md"
							>
								{calendar.name}
							</Box>
						);
					})}
				</Box>
			</Box>
			<Button my={4} colorScheme="primary" w="full" onClick={handleCreateCalendarClick}>
				{t('Create calendar')}
			</Button>
		</PageSectionTemplate>
	);
}
